import { AUTHORIZATION_HEADER } from '../../../src/authorization';
import { send } from '../../../src/network';

type Params = {
  orderId: number;
  promo: string;
};

export async function postSubmitPromo({ orderId, promo }: Params) {
  return send<unknown>({
    method: 'POST',
    path: '/api/submit_promo/',
    body: {
      order_id: orderId,
      promo,
    },
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
  });
}
